import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function PulseLineIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 44 44">
      <path
        d="M42 22H37.04C36.1659 21.9981 35.3153 22.2826 34.6182 22.8099C33.9212 23.3373 33.416 24.0784 33.18 24.92L28.48 41.64C28.4497 41.7439 28.3865 41.8351 28.3 41.9C28.2135 41.9649 28.1082 42 28 42C27.8918 42 27.7865 41.9649 27.7 41.9C27.6135 41.8351 27.5503 41.7439 27.52 41.64L16.48 2.36C16.4497 2.25614 16.3865 2.16491 16.3 2.1C16.2135 2.03509 16.1082 2 16 2C15.8918 2 15.7865 2.03509 15.7 2.1C15.6135 2.16491 15.5503 2.25614 15.52 2.36L10.82 19.08C10.5849 19.9183 10.0828 20.657 9.38973 21.184C8.69669 21.711 7.85064 21.9975 6.98 22H2"
        fill="none"
        stroke="currentColor"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
